import React, { useEffect, useRef, useState } from "react";
import { SelectInput } from "../../Components";

import { Modal } from "../../Components";
import { rechargeService } from '../../Services';
export default function ModalToken({ close, setIsTokenAdded, addToast, tokenPlan }) {
  const stripe = useRef(null);
  const [planSelected, setPlanSelected] = useState("");
  const [error, setError] = useState(false);
  const [toastList, setToastList] = useState([]);
  const [disableButton, setDisableButton] = useState(false);

  const addAmount = useRef(null);
  const changeSelectedPlan = (e) => {
    //console.log(e)
    setPlanSelected(e)
  }
  useEffect(() => {
    const keyDownHandler = event => {
      if (event.key === 'Enter') {
        addAmount.current.click();
      }
    };
    document.addEventListener('keydown', keyDownHandler);
    return () => {
      document.removeEventListener('keydown', keyDownHandler);
    };
  }, [planSelected]);

  const saveChanges = () => {
    if (planSelected !== "") {
      rechargeToken();
    }
  };

  const rechargeToken = async () => {
    const payload = {
      plan_id: planSelected.value,
      id: planSelected.id,
      amount: planSelected.amount
    };
    setDisableButton(true);
    try {
      const res = await rechargeService.rechargeToken(payload);
      if (res?.url) {
        window.location.replace(res.url);
        setIsTokenAdded(false);
      }
    } catch (error) {
      console.error('Recharge token error:', error);
      setDisableButton(false);
      addToast({
        error: true,
        msg: error?.message.message || 'Failed to process payment',
        id: `${Date.now()}-${toastList.length}`
      });
    }
  };
  return (
    <Modal addClass="modalFunds" close={close}>
      <div className="modal__funds addtokenselect">
        <div className="modal__funds-inner">
          <h3 className="big">Add token</h3>
          <p className="sm">
            Please select package
          </p>
          <div className="modal__funds-radio">

            <div className="modal__funds-radio-item">
              <input
                ref={stripe}
              />
            </div>
          </div>
          <div className="modal__funds-input">
            <SelectInput
              errorText="Please select token package "
              list={tokenPlan}
              selected={tokenPlan.filter(item => item.id === planSelected)[0]}
              onChange={changeSelectedPlan}
              error={error}
              value={planSelected}
            />
          </div>
          <button ref={addAmount} className="button primary addtokenbutton" disabled={disableButton} onClick={() => {
            saveChanges();
            setError(true);
          }}>
            Purchase
          </button>
        </div>
      </div>
    </Modal>
  );
}
